/** @jsx jsx */

import React from 'react';
import { jsx } from '@emotion/core';
import useReactRouter from 'use-react-router';
import useWorkflow from 'hooks/useWorkflow';
import { useTheme } from 'emotion-theming';
import { Theme } from 'features/Theme';
import BackButton from 'features/BackButton';
import useTranslate from 'hooks/useTranslate';

const EmbeddedBackButton: React.FC = () => {
  const theme = useTheme<Theme>();
  const t = useTranslate();
  const {
    location: { pathname },
  } = useReactRouter();
  const {
    steps,
    workflow: { paths },
  } = useWorkflow();

  if (!theme.embedded || pathname === paths[steps[0]]) {
    return null;
  }

  return <BackButton>{t('embeddedBackButton')}</BackButton>;
};

export default EmbeddedBackButton;
